import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	searchSuggestionsDropdown: {
		id: 'search-page.dropdown.search-suggestions',
		defaultMessage: 'Search Suggestions Dropdown',
		description: 'Aria label for search suggestions dropdown',
	},
});
